<form class="ngsild-form" [formGroup]="form">
  <div class="ngsild-form__row">
    <div class="ngsild-form__field">
      <label class="ngsild-form__label" for="model-industry">
        Industry <span class="ngsild-form__required">*</span>
      </label>
      <div class="custom-dropdown-wrapper">
        <div
          id="model-industry"
          class="custom-dropdown-trigger"
          [class.error]="showError('industry')"
          [class.open]="isDropdownOpen('industry')"
          (click)="toggleDropdown('industry')"
        >
          <div class="trigger-content">
            @if (!form.controls.industry.value) {
              <span class="placeholder">Select industry</span>
            } @else {
              <span class="selected-value">{{ getSelectedLabel('industry') }}</span>
            }
          </div>
          <svg class="dropdown-arrow" [class.open]="isDropdownOpen('industry')" width="12" height="8" viewBox="0 0 12 8" fill="none" aria-hidden="true">
            <path d="M1 1L6 6L11 1" stroke="#666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        @if (isDropdownOpen('industry')) {
          <div class="custom-dropdown-panel" (click)="$event.stopPropagation()">
            @for (opt of industryOptions; track opt.value) {
              <div class="dropdown-option" (click)="selectOption('industry', opt)">
                <div class="checkbox-wrapper">
                  <input type="checkbox" class="checkbox-custom" [checked]="isSelected('industry', opt.value)" readonly tabindex="-1"/>
                </div>
                <span class="option-label">{{ opt.label }}</span>
              </div>
            }
          </div>
        }
      </div>
      @if (showError('industry')) {
        <p class="ngsild-form__error">Industry is required</p>
      }
    </div>

    <div class="ngsild-form__field">
      <label class="ngsild-form__label" for="model-license">
        License <span class="ngsild-form__required">*</span>
      </label>
      <div class="custom-dropdown-wrapper">
        <div
          id="model-license"
          class="custom-dropdown-trigger"
          [class.error]="showError('license')"
          [class.open]="isDropdownOpen('license')"
          (click)="toggleDropdown('license')"
        >
          <div class="trigger-content">
            @if (!form.controls.license.value) {
              <span class="placeholder">Select license</span>
            } @else if (form.controls.license.value === 'Other') {
              <span class="selected-value">Other</span>
            } @else {
              <span class="selected-value">{{ getSelectedLabel('license') }}</span>
            }
          </div>
          <svg class="dropdown-arrow" [class.open]="isDropdownOpen('license')" width="12" height="8" viewBox="0 0 12 8" fill="none" aria-hidden="true">
            <path d="M1 1L6 6L11 1" stroke="#666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        @if (isDropdownOpen('license')) {
          <div class="custom-dropdown-panel" (click)="$event.stopPropagation()">
            @for (opt of licenseOptions; track opt.value) {
              <div class="dropdown-option" (click)="selectOption('license', opt)">
                <div class="checkbox-wrapper">
                  <input type="checkbox" class="checkbox-custom" [checked]="isSelected('license', opt.value)" readonly tabindex="-1"/>
                </div>
                <span class="option-label">{{ opt.label }}</span>
              </div>
            }
          </div>
        }
      </div>
      @if (showError('license')) {
        <p class="ngsild-form__error">License is required</p>
      }
      @if (isOtherLicenseSelected()) {
        <div class="ngsild-form__field ngsild-form__field--nested">
          <label class="ngsild-form__label" for="model-other-license">
            Specify License <span class="ngsild-form__required">*</span>
          </label>
          <input
            id="model-other-license"
            type="text"
            class="ngsild-form__input ngsild-form__input--single-line"
            formControlName="otherLicense"
            placeholder="Enter license name"
            [class.ngsild-form__input--error]="showError('otherLicense')"
          />
          @if (showError('otherLicense')) {
            <p class="ngsild-form__error">Please specify the license name</p>
          }
        </div>
      }
    </div>
  </div>

  <div class="ngsild-form__row">
    <div class="ngsild-form__field">
      <label class="ngsild-form__label" for="model-type">
        Model Type <span class="ngsild-form__required">*</span>
      </label>
      <div class="custom-dropdown-wrapper">
        <div
          id="model-type"
          class="custom-dropdown-trigger"
          [class.error]="showError('modelType')"
          [class.open]="isDropdownOpen('modelType')"
          (click)="toggleDropdown('modelType')"
        >
          <div class="trigger-content">
            @if (!form.controls.modelType.value) {
              <span class="placeholder">Select model type</span>
            } @else {
              <span class="selected-value">{{ getSelectedLabel('modelType') }}</span>
            }
          </div>
          <svg class="dropdown-arrow" [class.open]="isDropdownOpen('modelType')" width="12" height="8" viewBox="0 0 12 8" fill="none" aria-hidden="true">
            <path d="M1 1L6 6L11 1" stroke="#666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        @if (isDropdownOpen('modelType')) {
          <div class="custom-dropdown-panel" (click)="$event.stopPropagation()">
            @for (opt of modelTypeOptions; track opt.value) {
              <div class="dropdown-option" (click)="selectOption('modelType', opt)">
                <div class="checkbox-wrapper">
                  <input type="checkbox" class="checkbox-custom" [checked]="isSelected('modelType', opt.value)" readonly tabindex="-1"/>
                </div>
                <span class="option-label">{{ opt.label }}</span>
              </div>
            }
          </div>
        }
      </div>
      @if (showError('modelType')) {
        <p class="ngsild-form__error">Model type is required</p>
      }
    </div>

    <div class="ngsild-form__field">
      <label class="ngsild-form__label" for="model-file-format">
        File Format <span class="ngsild-form__required">*</span>
      </label>
      <div class="custom-dropdown-wrapper">
        <div
          id="model-file-format"
          class="custom-dropdown-trigger"
          [class.error]="showError('fileFormat')"
          [class.open]="isDropdownOpen('fileFormat')"
          (click)="toggleDropdown('fileFormat')"
        >
          <div class="trigger-content">
            @if (!form.controls.fileFormat.value) {
              <span class="placeholder">Select file format</span>
            } @else {
              <span class="selected-value">{{ getSelectedLabel('fileFormat') }}</span>
            }
          </div>
          <svg class="dropdown-arrow" [class.open]="isDropdownOpen('fileFormat')" width="12" height="8" viewBox="0 0 12 8" fill="none" aria-hidden="true">
            <path d="M1 1L6 6L11 1" stroke="#666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        @if (isDropdownOpen('fileFormat')) {
          <div class="custom-dropdown-panel" (click)="$event.stopPropagation()">
            @for (opt of fileFormatOptions; track opt.value) {
              <div class="dropdown-option" (click)="selectOption('fileFormat', opt)">
                <div class="checkbox-wrapper">
                  <input type="checkbox" class="checkbox-custom" [checked]="isSelected('fileFormat', opt.value)" readonly tabindex="-1"/>
                </div>
                <span class="option-label">{{ opt.label }}</span>
              </div>
            }
          </div>
        }
      </div>
      @if (showError('fileFormat')) {
        <p class="ngsild-form__error">File format is required</p>
      }
    </div>
  </div>

  <div class="ngsild-form__field">
    <div class="ngsild-tags-header">
      <label class="ngsild-form__label" for="model-tags-input">
        Tags <span class="ngsild-form__required">*</span>
      </label>
      <p class="ngsild-form__help ngsild-form__help--inline">
        Each tag can be up to {{ tagMaxLength }} characters (letters and numbers only).
      </p>
    </div>
    <div class="ngsild-tags" [class.ngsild-tags--error]="showError('tags')">
      <div class="ngsild-tags__input-row" [class.ngsild-tags__input-row--error]="showError('tags')">
        <input
          id="model-tags-input"
          type="text"
          class="ngsild-tags__input"
          placeholder="Enter a tag"
          [maxlength]="tagMaxLength"
          [(ngModel)]="tagInput"
          [ngModelOptions]="{ standalone: true }"
          (keydown)="onTagInputKeydown($event)"
          (input)="onTagInputChange()"
          (paste)="onTagInputPaste($event)"
        />
        <button
          type="button"
          class="ngsild-tags__add"
          title="Add tag"
          [disabled]="!canAddTag()"
          (click)="addTag()"
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <path d="M8 3V13M3 8H13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
      @if (tags.length > 0) {
        <div class="ngsild-tags__list">
          @for (tag of tags; track tag) {
            <span class="ngsild-tags__chip">
              {{ tag }}
              <button type="button" class="ngsild-tags__chip-remove" aria-label="Remove tag" (click)="removeTag(tag)">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                  <path d="M10.5 3.5L3.5 10.5M3.5 3.5L10.5 10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
              </button>
            </span>
          }
        </div>
      }
    </div>
    @if (showError('tags')) {
      <p class="ngsild-form__error">At least one tag is required</p>
    }
  </div>

  <div class="ngsild-form__field">
    <lib-additional-info />
  </div>
</form>
